import React from 'react';

import { SvgIcon } from '@mui/material';

import { IconColors } from './icon-utils';

export function ExpandedList8Icon(): JSX.Element {
  return (
    <SvgIcon style={{ height: 86, width: 62 }} viewBox="0 0 62 82">
      <g fill="none" fillRule="evenodd">
        <text
          fill="#324A52"
          fontFamily="Open Sans"
          fontSize="12"
          fontWeight="400"
          transform="translate(0 -2)"
        >
          <tspan x="0" y="10">
            ❖
          </tspan>
        </text>
        <text
          fill="#324A52"
          fontFamily="Open Sans"
          fontSize="12"
          fontWeight="400"
          transform="translate(0 -2)"
        >
          <tspan x="0" y="82">
            ❖
          </tspan>
        </text>
        <text
          fill="#324A52"
          fontFamily="Open Sans"
          fontSize="12"
          fontWeight="400"
          transform="translate(0 -2)"
        >
          <tspan x="15" y="27">
            ➢
          </tspan>
        </text>
        <text
          fill="#324A52"
          fontFamily="Open Sans"
          fontSize="12"
          fontWeight="400"
          transform="translate(0 -2)"
        >
          <tspan x="15" y="45">
            ➢
          </tspan>
        </text>
        <text
          fill="#324A52"
          fontFamily="Open Sans"
          fontSize="12"
          fontWeight="400"
          transform="translate(0 -2)"
        >
          <tspan x="31" y="65">
            ■
          </tspan>
        </text>
        <path
          d="M15 6H62V8H15zM15 78H62V80H15zM31 23H62V25H31zM31 41H62V43H31zM42 59H62V61H42z"
          fill={IconColors.Grey}
          transform="translate(0 -2)"
        />
      </g>
    </SvgIcon>
  );
}
